__turbopack_context__.v({
  "primaryButton": "Button-module__GQn9eq__primaryButton",
  "primaryButton--onNeutral": "Button-module__GQn9eq__primaryButton--onNeutral",
  "secondaryButton": "Button-module__GQn9eq__secondaryButton",
  "secondaryButton--onPrimary": "Button-module__GQn9eq__secondaryButton--onPrimary",
});
